import React from 'react';
import FilterButton from '../FilterIconComponent/FilterIcon';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import pdfIcon  from "../../assets/VI/excel.png";
import {  faFilePdf  } from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";
import ExcelJS from 'exceljs';
import pdfMake from "pdfmake/build/pdfmake";


const ExportBtn = ({setShowSearchForm , showSearchForm , subCategory , sortedData , category , dropdownYear , dropdownIndustryType}) => {
    // const handleFilterBtn = () => {
    //     setShowSearchForm(!showSearchForm)
    // }
    const base64code = "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";
    const description = "Venture Intelligence League Table represent a pioneering initiative dedicated to meticulously tracking transactions involving companies based in India. These tables are founded on the valuation of Private Equity (PE) and Merger and Acquisition (M&A) transactions, guided by Transaction and Legal Advisory firms throughout the calendar year. The data for these tables is derived from transactions submitted by advisory firms, meticulously filtered using Venture Intelligence definitions.";
    
    // Helper function to format numbers with commas (for PDF only)
    const formatNumber = (num) => {
        if (num === undefined || num === null) return "";
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
    
    const exportToExcel = () => {
        try {
            const tableId = "table-to-export";
            const fileName = `transaction_advisors_${subCategory}.xlsx`;
            const table = document.getElementById(tableId);
        
            // Create a new workbook and worksheet
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
        
            // Convert the table to a worksheet
            const originalWs = XLSX.utils.table_to_sheet(table);
        
            // Calculate the starting row for printing data (5th row in Excel is index 4)
            const startingRow = 4;
        
            // Add logo and description to specific cells in rows 1 and 2
            // Add an image to cell A1
            const imageId = workbook.addImage({
                base64: base64code,
                extension: 'png',
            });
        
            worksheet.addImage(imageId, {
                tl: { col: 0, row: 0 },
                br: { col: 1, row: 1 },
                editAs: 'twoCell',
            });

            // Set the description in cell C2 with word wrapping and text wrapping
            worksheet.getCell('A2').value = description;
            worksheet.getCell('A2').comment = { text: 'Description for Row 2' };
            worksheet.getCell('A2').alignment = {  wrapText: true , horizontal:"right" , vertical:"justify" };
        
            worksheet.getCell('A3').value = `Top ${category==="t" ? "Transactions" : "Legal"} Advisors - ${subCategory === "ma" ? "M&A" : subCategory.toUpperCase()} (${dropdownYear ? dropdownYear : 2013}) in ${dropdownIndustryType ? ` ${dropdownIndustryType}`  : "Overall"}`;
            worksheet.getCell('A3').alignment = {  wrapText: true , horizontal:"center" , vertical:"middle" };
            
            // Get data from table
            const data = XLSX.utils.sheet_to_json(originalWs, { header: 1 });
            
            // Add data to worksheet
            worksheet.addRows(data, { origin: startingRow });
            
            // Apply number format to amount column (D) to show commas
            const amountColumn = worksheet.getColumn('D');
            amountColumn.eachCell({ includeEmpty: false }, (cell, rowNumber) => {
                if (rowNumber > startingRow && typeof cell.value === 'number') {
                    // Use Excel's built-in number format with commas
                    cell.numFmt = '#,##0'; // This format adds commas for thousands
                }
            });
        
            // Apply gold color to cells A3, B3, C3, D3
            const goldFill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'f0f8ff' }, // Gold color
            };
        
            worksheet.getCell('A4').fill = goldFill;
            worksheet.getCell('B4').fill = goldFill;
            worksheet.getCell('C4').fill = goldFill;
            worksheet.getCell('D4').fill = goldFill;
        
            // Change font color of A3, B3, C3, D3 to b5844c
            worksheet.getCell('A4').font = { color: { argb: 'b5844c' }, bold: true };
            worksheet.getCell('B4').font = { color: { argb: 'b5844c' }, bold: true };
            worksheet.getCell('C4').font = { color: { argb: 'b5844c' }, bold: true };
            worksheet.getCell('D4').font = { color: { argb: 'b5844c' }, bold: true };
            worksheet.getCell('A3').font = { color: { argb: 'b5844c' }, bold: true };
        
            // Set width for specific columns
            worksheet.getColumn('A').width = 25; // Adjust the width as needed
            worksheet.getColumn('B').width = 25;
            worksheet.getColumn('C').width = 20;
            worksheet.getColumn('D').width = 20;

            // Set the height of rows 1 and 2 to match the image dimensions
            worksheet.getRow(1).height = 40;
            worksheet.getRow(2).height = 20;
            worksheet.getRow(3).height = 20;
            worksheet.mergeCells('A2:N2');
            worksheet.mergeCells('A3:C3');

            // Add an empty row (3rd row)
            worksheet.addRow([]);
        
            // Center data in columns A, C, D
            ['A' , 'B' , 'C', 'D'].forEach((column) => {
                worksheet.getColumn(column).alignment = { horizontal: 'center' };
            });
        
            // Save the workbook
            workbook.xlsx.writeBuffer().then((buffer) => {
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                console.log('Excel file downloaded successfully');
            });
            } catch (error) {
            console.error('Error exporting table to Excel:', error);
            }
        };
    
    
        const exportToPDF = () => {
            try {
                // Check if sortedData is not null or undefined
                if (sortedData && sortedData.length > 0) {
                    const data = sortedData.map((league, index) => [
                        index + 1,
                        league.advisor_name,
                        league.deal_count,
                        formatNumber(league.amount_sum), // Format the amount with commas for PDF
                    ]);
        
                    // Add logo in the center of the first row
                    const logoContent = {
                        image: `data:image/png;base64,${base64code}`, // Your base64 encoded logo
                        width: 120, // Adjust the width as needed
                        alignment: 'center',
                    };
        
                    const titleContent = {
                        text: ` Venture Intelligence League Table `,
                        fontSize: 16,
                        bold: true,
                        color:"#a26f35",
                        alignment: 'right', // Align the text to the right
                        margin: [0, 10, 30, 20], // Adjust the margin as needed
                    };

                    const descriptionContent = {
                        text: description,
                        fontSize: 12,
                        alignment: 'justify', // Align the text to justify
                        margin: [0, 0, 0, 10], // Adjust the margin as needed
                    };

                    const subTitleContent = {
                        text: `Top ${category==="t" ? "Transactions" : "Legal"} Advisors - ${subCategory === "ma" ? "M&A" : subCategory.toUpperCase()} (${dropdownYear ? dropdownYear : 2013}) in ${dropdownIndustryType ? ` ${dropdownIndustryType}`  : "Overall"}`,
                        fontSize: 14,
                        bold: true,
                        alignment: 'center', // Align the text to the center
                        margin: [0, 10, 0, 20], // Adjust the margin as needed
                    };  
                    const promotionContent = {
                        columns: [
                            logoContent,
                            titleContent,
                        ],
                    };

                    const additionalRow = [descriptionContent, subTitleContent];

                    const tableContent = {
                        table: {
                            headerRows: 1,
                            widths: [80, 200, 90, 90], // Adjust the widths of each column as needed
                            height:20,
                            body: [
                                [
                                    { text: "Rank", fillColor: '#f0f8ff' , color : '#a26f35' , alignment: 'center'  , style: 'tableHeader' },
                                    { text: "Company Name", fillColor: '#f0f8ff', color : '#a26f35' , alignment: 'center'  , style: 'tableHeader' },
                                    { text: "# of Deals", fillColor: '#f0f8ff', color : '#a26f35' , alignment: 'center' , style: 'tableHeader' },
                                    { text: "Amount $M", fillColor: '#f0f8ff', color : '#a26f35' , alignment: 'center' , style: 'tableHeader' },
                                ],
                                ...data.map(row => row.map(cell => ({ text: cell, alignment: 'center' }))),
                            ],                        
                        },            
                        styles: {
                            tableHeader: {
                                bold: true,
                                alignment: 'center',
                            },
                        },
                    };
                    
                    const watermarkContent = {
                        absolutePosition: { x: 150, y: 400 }, // Adjust the position of the watermark
                        image: 'data:image/png;base64,' + base64code, // Replace with your watermark image base64 code
                        width: 300, // Adjust the width of the watermark image
                        opacity: 0.2,
                    };
                    
        
                    const docDefinition = {
                        content: [
                            promotionContent,  // First row
                            additionalRow,     // Second row
                            [tableContent],    // Third row
                        ],
                         // Add the watermark content to each page
                        background: function (currentPage, pageSize) {
                            return [watermarkContent];
                        },
                    };
        
                    pdfMake.createPdf(docDefinition).download(`transaction_advisors_${subCategory}.pdf`);
        
                    console.log("PDF generated successfully");
                } else {
                    console.error("Error exporting table to PDF: sortedData is null or empty");
                }
            } catch (error) {
                console.error("Error exporting table to PDF:", error);
            }
        };
        
    return (
        <div className="mt-5  flex  gap-2">
            {/* <button onClick={handleFilterBtn} > 
            <FilterButton />
            </button> */}
            
            <button className="cursor-pointer" onClick={exportToExcel}>
            <img src={pdfIcon} width={23} alt="PDF" />
            </button>

            <button className=" cursor-pointer" onClick={exportToPDF}>
            <FontAwesomeIcon icon={faFilePdf} size="lg" width={38}  style={{ color: "#b5844c" }} />
            </button>
        </div>
    )
}

export default ExportBtn